const nodeDigest256 = async (crypto, str) => crypto.createHash('sha256').update(str).digest();
const nodeRandomBytes = (crypto, size) => crypto.randomBytes(size);

export { nodeDigest256, nodeRandomBytes };
